import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { class: "text-center text-grey-600 mb-6" }
const _hoisted_4 = { class: "flex gap-3 mb-7 justify-center" }
const _hoisted_5 = ["id", "onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-center mb-8" }, [
        _createElementVNode("img", {
          src: "/public/images/logo-wide.svg",
          class: "auth-logo2"
        })
      ], -1)),
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "font-semibold text-center my-6" }, "Vérification de votre email", -1)),
      _createElementVNode("p", _hoisted_3, [
        _cache[3] || (_cache[3] = _createTextVNode(" Nous avons envoyé un code de vérification à ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("strong", null, _toDisplayString(_ctx.userEmail), 1)
      ]),
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otpCode, (digit, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
              key: index,
              type: "text",
              class: "form-control-code",
              id: `otp-${index}`,
              "onUpdate:modelValue": ($event: any) => ((_ctx.otpCode[index]) = $event),
              maxlength: "1",
              onInput: ($event: any) => (_ctx.handleInput(index, $event)),
              onKeydown: ($event: any) => (_ctx.handleKeydown(index, $event)),
              onPaste: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
              placeholder: "",
              inputmode: "numeric",
              pattern: "[0-9]"
            }, null, 40, _hoisted_5)), [
              [_vModelText, _ctx.otpCode[index]]
            ])
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn lg w-100 flex-center mt-5 mb-4",
          disabled: !_ctx.isCodeComplete || _ctx.isSubmitting
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: "/public/icons/icon-valider.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Vérification...' : 'Vérifier'), 1)
        ], 8, _hoisted_6),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resendCode && _ctx.resendCode(...args))),
          class: "btn lg w-100 flex-center btn-outline",
          disabled: _ctx.isResending
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.isResending ? 'Envoi en cours...' : 'Renvoyer le code'), 1)
        ], 8, _hoisted_7)
      ], 32),
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-read text-grey-600 text-center mt-5" }, " Vérifiez votre boîte de réception et vos spams si vous ne voyez pas l'email. ", -1))
    ])
  ]))
}